import React from 'react'
import Layout from "../components/Layout"
import BoxesShadow from "../components/BoxesShadow"
import OptionsBoxes from "../constants/development/theSSDifference"
import OurVision from  "../components/Design/OurVision"
import DevelopmentStage from "../components/Development/DevelopmentStage"
import Projects from "../components/Projects"
import Testimonials from "../components/Testimonials"

const Development = () => {
    return (
        <Layout
            title="DEVELOPMENT"
            subtitle="Bridging creativity with practicality"
        >
            <BoxesShadow 
                title="The Shopify Systems Difference"
                options={OptionsBoxes}
            />
            <OurVision />
            <DevelopmentStage />
            <Projects />
            <Testimonials />
        </Layout>
    )
}

export default Development
